/**
 * Traduz editedByCategory (estado interno do client, com campos computados)
 * para o contrato de payload que a API aceita — só os 3 raw values de Base
 * por (categoria, mês). Nunca inclui campos derivados (estoque, OTB, ideal)
 * nem `level` — o servidor sempre resolve level sozinho e recalcula a
 * cascata inteira a partir da Base recebida.
 */

export const buildOtbVersionPayload = (editedByCategory, editedAnchors) => {
  const validEdits = [];
  const incompleteEdits = [];

  Object.entries(editedByCategory || {}).forEach(([categoria, months]) => {
    const anchorKeys = Object.keys(editedAnchors?.[categoria] || {});

    anchorKeys.forEach((key) => {
      const edited = months?.[key];
      if (!edited) return;

      const [year, month] = key.split('-').map(Number);
      const entry = {
        categoria,
        year,
        month,
        grossRevenue: edited.grossRevenue,
        unitsSold: edited.unitsSold,
        originalPrice: edited.originalPrice,
      };

      validEdits.push(entry);

    });
  });

  return { validEdits, incompleteEdits };
};